export default {
  hasDashboard: false,
  isFixed: true,
  slug: "profile",
  display: false,
  menus: []
};